import {Component, OnInit} from '@angular/core';
import {ComboBoxOption} from '../../models/combo-box-option';
import {ReportService} from '../../services/report/report.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {
  ReportExportSpreadsheetService
} from '../../services/report/report-export/report-export-spreadsheet/report-export-spreadsheet.service';
import {
  ReportExportDocumentService
} from '../../services/report/report-export/report-export-document/report-export-document.service';
import {ReportFilterService} from '../../services/report/report-filter/report-filter.service';
import {ReportComboOptionsService} from '../../services/report/report-combo-options/report-combo-options.service';
import {MessageService} from 'primeng/api';
import {environment} from '../../../environments/environment';
import {ScrollService} from '../../services/scroll/scroll.service';
import {SessionService} from '../../services/session/session.service';
import { PaginateResult } from 'src/app/models/paginateresult';
import { ReportItem } from 'src/app/models/reportitem';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  reports!: ComboBoxOption[];
  selectedReport!: ComboBoxOption;
  reportKinds!: ComboBoxOption[];
  selectedReportKind!: ComboBoxOption;
  start!: Date;
  end!: Date;

  filters: any = {};
  filtersAsString: string = '';

  isLoading: boolean = false;
  isLoadingComboOptions: boolean = false;
  isFilterTouched: boolean = false;

  columns!: any[];
  records: any[] = [];

  comboOptions: any;
  reportTitle: string = '';
  displayExportDocumentReportTitle: boolean = false;

  selectedRecords: any[] = [];

  rowLimit:number = 5;
  orderData:PaginateResult<ReportItem> | undefined;
  reportOrderData:any[] = [];
  exportingOrder?:boolean = false;

  constructor(
    private reportService: ReportService,
    private reportComboOptionsService: ReportComboOptionsService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
  }

  public ngOnInit(): void {
    if (environment.useToken) {
      this.route.queryParams.subscribe((params: Params): void => {
        if (params['token']) {
          SessionService.setToken(params['token']);
          this.init();
        } else {
          this.router.navigateByUrl('/login').then((): void => {
          });
        }
      });
    } else {
      this.init();
    }
  }

  private init(): void {
    ScrollService.toTop();
    this.reportComboOptionsService.clear(this.comboOptions, (newOptions: any) => this.comboOptions = newOptions);

    this.reportService.all().then(data => {
      this.reports = data;
      this.selectedReport = this.reports[0];

      this.reportKinds = JSON.parse(this.selectedReport.value as string);
      this.selectedReportKind = this.reportKinds[0];
    });

    this.start = new Date();
    this.end = new Date();

    let interval: any = setInterval((): void => {
      if ((this.selectedReport) && (this.selectedReportKind)) {
        this.clearFilter();
        this.loadComboOptions().then((): void => {
        });
        clearInterval(interval);
      }
    }, 500);
  }

  private load(): void {
    if (this.start === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'O início do período precisa ser fornecido'
      });
      return;
    }

    if (this.end === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'O final do período precisa ser fornecido'
      });
      return;
    }

    if (this.start.getTime() > this.end.getTime()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'O início do período precisa ser menor ou igual o final'
      });
      return;
    }



    if ((this.selectedReport) && (this.selectedReportKind)) {
      this.isLoading = true;

      if(this.selectedReportKind.value !== '005'){
        this.columns = [];
        this.records = [];
      }

      if(this.selectedReportKind.value === '005'){
        this.loadOrder();
      }else if(this.selectedReportKind.value === '015'){

        const filters = Object.fromEntries(Object.entries(this.filters).filter(([_, value]) => value != null));


        this.reportService.reportProductionItem(filters).then((data) =>{
          this.columns = data.cols;
          this.records = data.records;
          console.log('resut', data);
          this.selectedRecords = [];

          this.records.forEach(record => this.selectedRecords.push(record));
        }).catch((e) =>{
          console.log("report_error", e)
        }).finally(() =>{
          this.isLoading = false;
        })
      }else{
        this.columns = [];
        this.records = [];
        this.reportService.get(this.selectedReportKind!.value!, this.start, this.end, this.filtersAsString).then(data => {
          this.columns = data.cols;
          this.records = data.records;

          this.selectedRecords = [];
          this.records.forEach(record => this.selectedRecords.push(record));

          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      }
    }
  }

  public loadOrder($evt?:any){
    this.records = [];
    this.columns = [
      {
        field:'dataCadastro',
        header:'Dada do pedido',
      },
      {
        field:'pedido',
        header:'Número do pedido',
      },
      {
        field:'classificacaoNome',
        header:'Classificação',
      },
      {
        field:'centroDistribuicaoNome',
        header:'Centro de distribuição',
      },
      {
        field:'localEntrega',
        header:'Local de entrega / prefixo',
      },
      {
        field:'solicitanteNome',
        header:'Solicitante',
      },
      {
        field:'uf',
        header:'UF',
      },
      {
        field:'situacaoNome',
        header:'Situação',
      },
      {
        field:'variedade',
        header:'Variedade',
      },
      {
        field:'quantidade',
        header:'Quantidade',
      },
      {
        field:'custoTotal',
        header:'Custo total',
      }
    ]
    this.rowLimit = !!$evt ? $evt.rows : 5;
    let filters = {...this.filters, ...{
      page:!!$evt ? ($evt.first / $evt.rows) : 0,
      size:this.rowLimit,
      export:false
    }}

    this.reportService.reportOrder(filters).then((data) =>{
      this.orderData = data;
      this.records = data.content;
    }).catch((e) =>{
      console.log("report_error", e)
    }).finally(() =>{
      this.isLoading = false;
    })
  }

  public onPageChange($evt: any): void {
    this.rowLimit = $evt?.rows || 5;
  }

  public onChangeReport(event: Event): void {
    console.log(event);
    this.reportKinds = JSON.parse(this.selectedReport.value as string);
    this.selectedReportKind = this.reportKinds[0];

    // Change values for today
    this.start = new Date();
    this.end = new Date();

    this.clearFilter();
    this.loadComboOptions().then((): void => {
    });
  }

  public onChangeReportKind(event: any): void {
    if (event == null) {
      this.reportKinds = JSON.parse(this.selectedReport.value as string);
      this.selectedReportKind = this.reportKinds[0];
    }

    // Change values for today
    this.start = new Date();
    this.end = new Date();

    this.clearFilter();
    this.loadComboOptions().then((): void => {
    });
  }

  public isReportKind(kind: string): boolean {
    return (this.selectedReportKind) && (this.selectedReportKind.value === kind);
  }

  public filter(): void {
    if(this.selectedReportKind && this.selectedReportKind.value !== '005'){
      this.filtersAsString = ReportFilterService.generate(this.selectedReportKind.value, this.filters)
    }

    this.isFilterTouched = true;

    this.load();
  }

  public clearFilter(): void {
    this.filters = {};
    this.filtersAsString = '';
    this.isFilterTouched = false;
    this.selectedRecords = [];
  }

  public exportSpreadsheet(): void {
    if (this.isNotSelectedRecords()) //
      return;
    if(this.selectedReportKind.value === "001"){

      const totalQuantity = this.records.reduce((sum, item) => sum + item.quantidade, 0);
      const totalStock = this.records.reduce((sum, item) => sum + item.estoque, 0);


      this.selectedRecords.push({
      cadastro: "Total",
      codigo: "",
      tipo: "",
      quantidade: totalQuantity,
      estoque: totalStock,
      disponibilidade: "",
      validade: ""
    })

      // this.records.map((item) => {
      //   return
      // })
    }
    console.log(this.selectedRecords)
    ReportExportSpreadsheetService.export(this.selectedRecords);
  }


  public exportOrder(): void {
    let filters = {...this.filters, ...{
      page:0,
      size:0,
      export:true
    }}
    this.exportingOrder = true;
    this.reportService.reportExportOrder(filters).then((data) =>{
     this.reportOrderData = data;

    }).catch((e) =>{
      console.log("report_error", e)
    }).finally(() =>{
      this.isLoading = false;
      this.exportingOrder = false;
    })
  }

  public exportOrderReport(type: 'CSV' | 'PDF'){
    this.exportOrder();

    if(type == 'CSV'){
      ReportExportSpreadsheetService.export(this.reportOrderData);
    }else{
      this.reportTitle = this.selectedReport.label + ' - Tipo: ' + this.selectedReportKind.label;
      this.displayExportDocumentReportTitle = true;
    }
  }

  public exportDocument(): void {
    if (this.isNotSelectedRecords()) //
      return;

    this.reportTitle = this.selectedReport.label + ' - Tipo: ' + this.selectedReportKind.label;
    this.displayExportDocumentReportTitle = true;
  }

  public exportDocumentWithTitle(): void {
    this.displayExportDocumentReportTitle = false;
    console.log(this.selectedRecords)
    console.log(this.isReportKind('005') ? this.reportOrderData : this.selectedRecords)
    ReportExportDocumentService.export(this.reportTitle, this.columns,this.isReportKind('005') ? this.reportOrderData : this.selectedRecords);
  }

  private async loadComboOptions(): Promise<void> {
    await this.reportComboOptionsService.clear(this.comboOptions, (newOptions: any) => {
      this.comboOptions = newOptions
    });
    console.log('otps',this.comboOptions);
    await this.reportComboOptionsService.load(this.comboOptions, this.selectedReportKind.value,
      (loading: boolean) => this.isLoadingComboOptions = loading,
      (newOptions: any) => this.comboOptions = newOptions);
  }


  private isNotSelectedRecords(): boolean {
    // console.log(this.selectedRecords);

    if (this.selectedRecords.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Precisa ser selecionado ao menos um resultado'
      });
      return true;
    }

    return false;
  }

}
